function listen(iframe) {
  const frame = iframe.contentWindow;
  if (!frame) return;

  const message = payload => frame.postMessage(JSON.stringify(payload), '*');
  message({ event: 'listening', id: 1, channel: 'widget' });
  message({
    event: 'command',
    func: 'addEventListener',
    args: ['onStateChange'],
    id: 1,
    channel: 'widget',
  });
}

export default function setHeroVideo() {
  const posters = document.querySelectorAll('[data-hero-poster]');

  posters.forEach(poster => {
    const iframe = poster.parentElement?.querySelector('iframe');
    if (!iframe) return;

    const hide = () => poster.classList.add('is-hidden');

    window.addEventListener('message', event => {
      if (event.source !== iframe.contentWindow) return;

      let data = event.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (error) {
          return;
        }
      }

      if (data?.event === 'onStateChange' && Number(data.info) === 1) hide();
    });

    iframe.addEventListener('load', () => listen(iframe));
    listen(iframe);
    window.setTimeout(hide, 8000);
  });
}
